import quarkusApi from '../api/quarkusApi';

// Apaga os lembretes vencidos e gera os dos próximos dias. O backend deixou de fazer isso por
// agendamento, então a atualização acontece quando o usuário entra na home.
// A operação é idempotente e nunca deve impedir a listagem: se falhar, seguimos com o GET.
export function refreshReminders() {
  return quarkusApi
    .post('/reminders/refresh', null, {
      headers: { Authorization: sessionStorage.getItem('token') },
    })
    .catch((returnFromApi) => {
      console.error('ops! ocorreu um erro' + returnFromApi);
    });
}
